<template>
  <v-card class="dashboard-item" @click="goTo()">
    <v-img
      v-if="showImage"
      :src="image"
      aspect-ratio="2.75"
    ></v-img>
    <div v-if="showIcon" class="icon-container d-flex justify-center align-center">
      <v-img v-if="iconURL" height="30" width="30" :src="iconURL" contain></v-img>
      <v-icon v-else color="primary lighten-1">{{ icon }}</v-icon>
    </div>
    <v-card-text class="d-flex align-center H4 text-color__dark">
      <span>{{ title }}</span>
    </v-card-text>
  </v-card>
</template>

<script>
import router from '@/router'
import routeNames from '@/router/routes'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { mapGetters } from 'vuex'
import { pageTypes, cardAppearanceTypes, preconfiguredPageRoutes } from '@/config'

export default {
  props: {
    page: Object,
    preconfiguredPage: Object,
  },
  data () {
    return {
      cardAppearanceTypes,
    }
  },
  computed: {
    ...mapGetters({ 
      authStatus: 'auth/authStatus',
      cardAppearance: 'service/getCardAppearance',
      authToken: 'auth/authToken',
    }),
    showImage () {
      return !!this.image && this.cardAppearance === cardAppearanceTypes.IMAGE
    },
    showIcon () {
      return( (!!this.icon || !!this.iconURL) && this.cardAppearance === cardAppearanceTypes.ICON)
        || (!this.image && this.cardAppearance === cardAppearanceTypes.IMAGE)
    },
    icon () {
      let icon = null
      if (this.page) {
        icon = this.page.icon
      } else if (this.preconfiguredPage) {
        icon = this.preconfiguredPage.icon
      }
      if (!icon) {
        icon = 'mdi-menu'
      }
      return icon
    },
    iconURL () {
      let icon = null
      if (this.page) {
        icon = this.page.iconUrl
      } else if (this.preconfiguredPage) {
        icon = this.preconfiguredPage.iconUrl
      }
      return icon
    },
    image () {
      let image = null
      if (this.cardAppearance === this.cardAppearanceTypes.IMAGE) {
        if (this.page) {
          image = this.page.coverImageUrl
        } else if (this.preconfiguredPage) {
          image = this.preconfiguredPage.coverImageUrl
        }
      }
      return image
    },
    title () {
      let title = null
      if (this.page) {
        switch (this.page.type) {
        case pageTypes.LINK:
          title = getTextValue(this.page.pageSpecific.button.title)
          break
        case pageTypes.SERVICE:
          title = getTextValue(this.page.pageSpecific.title)
          break
        case pageTypes.CONTENT:
          title = getTextValue(this.page.pageSpecific.title)
          break
        case pageTypes.NAVIGATION:
          title = getTextValue(this.page.pageSpecific.title)
          break
        default:
          break
        }
      } else if (this.preconfiguredPage) {
        title = getTextValue(this.preconfiguredPage.title)
      }
      return title
    },
    authenticated () {
      let authenticated = false
      if (this.page) {
        switch (this.page.type) {
        case pageTypes.LINK:
          authenticated = this.page.pageSpecific.button.authenticated
          break
        default:
          break
        }
      }
      return authenticated
    },
    url () {
      let url = null
      if (this.page) {
        switch (this.page.type) {
        case pageTypes.LINK:
          url = this.page.pageSpecific.button.url
          break
        default:
          break
        }
      } else if (this.preconfiguredPage) {
        url = preconfiguredPageRoutes[this.preconfiguredPage.pageName]
      }
      return url
    },
  },
  methods: {
    goTo () {
      if (!this.url) {
        this.$store.commit('pages/setPage', this.page)
        router.push({ name: routeNames.page_details.name, params: { pageId: this.page.id }})
        return
      } else {
        if (this.url.startsWith('http')) {
          if (this.authenticated && !this.authStatus) {
            router.push({ name:'login', query: { ['next-url']: this.url }})
          } else {
            if (this.url && this.authenticated) {
              const url = `${ this.url }?x-api-key=${ this.authToken }`
              window.open(url, '_blank')
            } else {
              window.open(this.url, '_blank')
            }
          }
        } else {
          if (!!routeNames[this.url]) {
            router.push({ name: this.url })
          } else {
            router.push({ path: this.url })
          }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .dashboard-item {
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    height: 70px;
    border: 1px solid var(--v-custom-grey-lighten1);
    box-shadow: 0px 0px 28px 0px rgba(0, 0, 0, 0.10) !important;
    .v-image, .icon-container {
      width: 90px !important;
      min-width: 90px;
      border-radius: 10px 0 0 10px !important;
    }
    .icon-container {
      background-color: rgba(var(--v-primary-lighten1-rgb), 0.1);
    }
    .v-card__text {
      padding: 21px;
      vertical-align: middle;
    }
  }
</style>
